module.exports = __webpack_public_path__ + "img/表1-6圆切线的画法.1e103110.png";